module Meevo.Plugins.Client {

    class ClientHistoryNoteController {

        static $inject = ['$mdDialog'];
        public notes: any;
        public isFalse: boolean = false;
        public isTrue: boolean = true;
        
        constructor(
            protected $mdDialog: angular.material.IDialogService) { }

        cancel = () => {
            this.$mdDialog.hide();
        };

        getNoteBySaleNoteTypeEnum = (type: number) => {
            var theseNotes = this.notes.filter(x => x.saleNoteTypeEnum === type);
            return theseNotes.length > 0 ? theseNotes[0].noteText : "";
        }

    }

    angular.module('meevo.plugins.client')
        .controller('meevo.plugins.client.ClientHistoryNoteController', ClientHistoryNoteController);
}